// src/components/ProductDrop.jsx
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import "./product_drop.css";

/* ---------------------------------------------
   Small helpers
--------------------------------------------- */
const cls = (...parts) => parts.filter(Boolean).join(" ");

function ProductCard({
  boxClass = "",
  titleTop,
  titleBottom,
  titleTopClass = "apple-h3a sanz-thick",   // thicker, per your note
  titleBottomClass = "apple-h2a sanz-thick",
  gradientBottom = true,                     // whether bottom title gets gradient
  dimBottom = false,                         // whether bottom title gets dim style
  valueText,
  linkHref,
  linkLabel = "View in Our Shop",
  imgSrc,
  imgAlt,
  lift = "sm",                               // image lift: "sm" | "md" | "lg"
}) {
  return (
    <article className={cls("pd-card", boxClass)} aria-label={`${titleTop ?? ""} ${titleBottom ?? ""}`.trim()}>
      {/* Titles */}
      {titleTop && (
        <h2 className={cls("pd-title pd-title--top", titleTopClass)}>
          {titleTop}
        </h2>
      )}
      {titleBottom && (
        <h2
          className={cls(
            "pd-title pd-title--bottom",
            titleBottomClass,
            gradientBottom && "pd-title--gradient",
            dimBottom && "pd-title--dim"
          )}
        >
          {titleBottom}
        </h2>
      )}

      {/* Spacer to push image slightly higher. You can tune in CSS. */}
      <div className="pd-spacer" aria-hidden="true" />

      {/* Media */}
      <div className={cls("pd-media", lift && `pd-media--lift-${lift}`)}>
        <img
          className="pd-img"
          src={imgSrc}
          alt={imgAlt}
          loading="lazy"
          decoding="async"
        />
      </div>

      {/* Details */}
      {(valueText || linkHref) && (
        <div className="product-details">
          {valueText && <span className="pd-value">{valueText}</span>}
          {linkHref && (
            <>
              {valueText && <br />}
              <a
                href={linkHref}
                target="_blank"
                rel="noopener noreferrer"
                className="shop-link shop-link--pretty"
              >
                {linkLabel}
              </a>
            </>
          )}
        </div>
      )}
    </article>
  );
}

export default function ProductDrop() {
  const products = useMemo(
    () => ({
      machine: {
        titleTop: "INK",
        titleBottom: "BRUSH.",
        titleTopClass: "apple-h2 sanz-thick",
        titleBottomClass: "apple-h3 sanz-thick",
        valueText: "Valued at $399",
        linkHref:
          "https://shop.cosmetink.com/cosmetink/collections/machines/cosmetink/inkbrush",
        imgSrc: "https://cosmetinkshop.s3.us-east-2.amazonaws.com/inkbrush.PNG",
        imgAlt: "COSMETINK® INK BRUSH machine",
        taglineText: "It's Revolutionary.",
      },
      needles: [
        {
          titleTop: "Powdery",
          titleBottom: "Pixel",
          valueText: "Box valued at $39",
          linkHref:
            "https://shop.cosmetink.com/cosmetink/collections/needles/cosmetink/powderypixel",
          imgSrc: "https://cosmetinkshop.s3.us-east-2.amazonaws.com/IMG_2133.PNG",
          imgAlt: "Powdery Pixel needle box",
        },
        {
          titleTop: "Detailed",
          titleBottom: "Definition",
          valueText: "Box valued at $32",
          linkHref:
            "https://shop.cosmetink.com/cosmetink/collections/needles/cosmetink/detaileddefinition",
          imgSrc: "https://cosmetinkshop.s3.us-east-2.amazonaws.com/IMG_2131.PNG",
          imgAlt: "Detailed Definition needle box",
        },
      ],
    }),
    []
  );

  return (
    <section className="product-drop" aria-label="COSMETINK® Featured Products">
      {/* HERO ROW (always its own row on desktop) */}
      <article className="pd-card pd-hero">
        <h2 className={cls("pd-title pd-title--top pd-title--gradient", products.machine.titleTopClass)}>
          {products.machine.titleTop}
        </h2>
        <h2 className={cls("pd-title pd-title--bottom pd-title--dim", products.machine.titleBottomClass)}>
          {products.machine.titleBottom}
        </h2>

        <div className="inkbrush-text gray-font sanz-reg fade-in">
          {products.machine.taglineText}
        </div>

        <div className="inkbrush-details">
       
        </div>

        <div className="pd-media pd-media--hero pd-media--lift-md">
          <img
            className="pd-img"
            src={products.machine.imgSrc}
            alt={products.machine.imgAlt}
            loading="lazy"
            decoding="async"
          />
          
        </div>
        <br/>
           <span className="pd-value">{products.machine.valueText}</span>
          <br />

                  <a
            className="shop-link shop-link--pretty"
            href={products.machine.linkHref}
            target="_blank"
            rel="noopener noreferrer"
          >
            View in Our Shop
          </a>
      </article>

      {/* NEEDLES GRID (2-up desktop, 1-up mobile) */}
      <div className="pd-needles">
        {products.needles.map((p, i) => (
          <ProductCard
            key={i}
            {...p}
            boxClass="pd-needle"
            lift="sm"
            // Bottom title gets gradient by default; keep dim off for needles
            gradientBottom={true}
            dimBottom={false}
            titleTopClass="apple-h3a sanz-thick"
            titleBottomClass="apple-h2a sanz-thick"
          />
        ))}
      </div>
    </section>
  );
}
